import { GroundMesh } from "@babylonjs/core/Meshes/groundMesh";
import { MeshBuilder } from "@babylonjs/core/meshes/meshBuilder";

export default class Ground {

    constructor(scene) {

        const ground = MeshBuilder.CreateGround("ground", {
            width: 60,
            height: 50,
            subdivisions: 0,
        }, scene);

        ground.position.y = -10;

        ground.checkCollisions = true;
        ground.receiveShadows = true;
    }
}
